<template>
  <div class="card">
    <div class="card-body">
      <b-table
          :items="stockCategoryList"
          :fields="stockCategoryListHeaders"
          hover
          responsive
          sort-icon-left
          :busy="stockCategoryListLoading"
          head-row-variant="info"
          table-variant="white"
          show-empty
      >
        <template #empty="scope">
          <h6 class="text-center my-5">
            {{ scope.loading ? "Lütfen Bekleyin" : errorMessageAll ? errorMessageAll : "Veri Bulunamadı" }}
          </h6>
        </template>
        <template #table-busy>
          <div class="text-center">
            <b-spinner
                variant="primary"
                size="lg"
                label="Lütfen Bekleyin..."
            ></b-spinner>
          </div>
        </template>
        <template #cell(isActive)="data">
          <v-chip small label :color="data.item.isActive ? 'success ligthen-2' : 'secondary ligthen-2'">
            {{ data.item.isActive ? 'Aktif' : 'Pasif' }}
          </v-chip>
        </template>
        <template #cell(parentCategory)="data">
          {{ stockCategoryList.find(x => x.id === data.item.baseId) ? stockCategoryList.find(x => x.id === data.item.baseId).name : "-"}}
        </template>
        <template #cell(process)="data">
          <div class="text-center">
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                    v-bind="attrs"
                    v-on="on"
                    icon
                    color="amber darken-2"
                    @click="openStockCategoryDialog(data.item)"
                >
                  <v-icon>mdi-pencil-outline</v-icon>
                </v-btn>
              </template>
              <span>Düzenle</span>
            </v-tooltip>
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn v-bind="attrs" v-on="on" icon color="danger darken-2" @click="_stockCategoryDelete(data.item.id)">
                  <v-icon>mdi-delete-outline</v-icon>
                </v-btn>
              </template>
              <span>Sil</span>
            </v-tooltip>
          </div>
        </template>
      </b-table>
      <EditStockCategoryDialog
          :stockCategoryProp="stockCategory"
          :processType="'edit'"
          :showDialog="editStockCategoryDialog"
          @dialogChange="(data) => (editStockCategoryDialog = data)"
      ></EditStockCategoryDialog>

    </div>
  </div>
</template>

<script>
import {mapActions, mapState} from "vuex";

import EditStockCategoryDialog from '@/components/management/stock-categories/dialogs/EditStockCategoryDialog.vue'



export default {
  props: {
    perPage: {
      type: Number,
    },
    currentPage: {
      type: Number,
    },
  },

  components: {
    EditStockCategoryDialog
  },

  computed: {
    ...mapState("dashboard", ["errorMessageAll"]),
    ...mapState("stock", ["stockCategoryList", "stockCategoryListHeaders", "stockCategoryListLoading"]),
  },
  mounted() {

  },
  data() {
    return {
      selectRow: false,
      userData: null,
      editStockCategoryDialog:false,
      stockCategory:null
    };
  },
  methods: {
    ...mapActions("stock", ["stockCategoryDelete"]),
    async _stockCategoryDelete(id){
      await this.stockCategoryDelete({
        params:{

        },
        body:{

        },
        urlSegments: [id]
      })
    },
    openStockCategoryDialog(data){
      this.stockCategory = Object.assign({},data);
      this.editStockCategoryDialog = true;
    },

  },
  watch: {},
};
</script>
